<template>
  <div class="author-page">
    <AuthorTopTab></AuthorTopTab>
    <div class="author-page-container">
      <router-view></router-view>
    </div>
    <AuthorBottomFooter></AuthorBottomFooter>
  </div>
</template>
<script>
import AuthorTopTab from '@/components/AuthorTopTab'
import AuthorBottomFooter from '@/components/AuthorBottomFooter'

export default {
  name: 'TheAuthorPage',
  components: { AuthorTopTab, AuthorBottomFooter },
  data() {
    return {}
  },
  created() {
    // const dispatch = this.$store.dispatch
    // // 刷新用户基础信息
    // dispatch('user/getUserInfo')
    // // 刷新用户权限列表
    // dispatch('right/getAllRightList')
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/style/variable/index.scss';
.author-page {
  min-height: 101vh;
  display: flex;
  flex-direction: column;
  background-color: #f0f0f0;
}

.author-page-container {
  flex: auto;
  width: $page-width;
  margin: 100px auto 0;
}
</style>
<style>
.author-page .author-page-container .el-input__inner {
  background-color: #ffffff;
}
:focus {
  border-color: #046bcc !important;
}
.author-page .author-page-container .el-form-item__label {
  padding: 0 18px 0 0;
  min-width: 100px;
  text-align: right;
}
.author-page .el-select .el-input.is-focus .el-input__inner {
  border-color: #046bcc;
}
body .el-textarea__inner {
  background-color: #ffffff;
}
/* radio */
body .el-radio__input.is-checked .el-radio__inner {
  border-color: #046bcc;
  background: #046bcc;
}
body .el-radio__input.is-checked + .el-radio__label {
  color: #046bcc;
}

.el-radio__input.is-disabled.is-checked.is-checked .el-radio__inner {
  background-color: #858585 !important;
  border-color: #858585 !important;
}
.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  background-color: #f0f0f0 !important;
}
.author-page .el-radio__input.is-disabled.is-checked + span.el-radio__label {
  color: #858585;
}
/* checkbox */
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #ffff;
}
.author-page .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #046bcc;
  border-color: #046bcc;
}
.author-page .el-input .el-input__count {
  height: auto;
}
.author-page
  .el-checkbox__input.is-disabled.is-checked
  + span.el-checkbox__label {
  color: #858585;
}
/* datetime */
.author-page .el-input__prefix .el-input__icon.el-icon-date {
  background: url('./images/date.png') no-repeat center;
  margin-left: 3px;
}
.author-page .el-input__prefix .el-input__icon.el-icon-date:before {
  content: '';
}
.author-page .el-input--prefix .el-input__inner {
  padding-left: 40px;
}

/* alert btn */
body .el-message-box__btns {
  padding: 8px 15px 5px;
  text-align: center;
}
body .el-message-box__message {
  padding: 15px 12px 15px 36px;
  color: #606266;
  font-size: 15px;
}

body .progress-style {
  vertical-align: middle !important;
}
</style>
